var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSolidExpand2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 1.99999C9.33337 1.63181 9.63185 1.33333 10 1.33333H14C14.3682 1.33333 14.6667 1.63181 14.6667 1.99999V6C14.6667 6.36819 14.3682 6.66666 14 6.66666C13.6319 6.66666 13.3334 6.36819 13.3334 6V3.60947L9.80478 7.13807C9.54443 7.39842 9.12232 7.39842 8.86197 7.13807C8.60162 6.87772 8.60162 6.45561 8.86197 6.19526L12.3906 2.66666H10C9.63185 2.66666 9.33337 2.36818 9.33337 1.99999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60952 13.3333L7.13811 9.80473C7.39846 9.54438 7.39846 9.12227 7.13811 8.86192C6.87776 8.60157 6.45565 8.60157 6.1953 8.86192L2.66671 12.3905L2.66671 10C2.66671 9.63181 2.36823 9.33333 2.00004 9.33333C1.63185 9.33333 1.33337 9.63181 1.33337 10V14C1.33337 14.3682 1.63185 14.6667 2.00004 14.6667H6.00004C6.36823 14.6667 6.66671 14.3682 6.66671 14C6.66671 13.6318 6.36823 13.3333 6.00004 13.3333H3.60952Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSolidExpand2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SolidExpand2.99ad27ef4c3b90b21ce64dbfe5629297.svg";